import { useNotificationStore } from '@/store/notificationStore';
import { useActiveUrlStore } from '@/store/activeUrlStore';
import useAuth from '@/composables/useAuth/useAuth';
import { GoogleAnalytics } from '@/services/analytics/googleAnalytics';

function exportNotificationsToJson() {
    GoogleAnalytics.exportButtonClick();

    const notificationStore = useNotificationStore();
    const activeUrlStore = useActiveUrlStore();
    const auth = useAuth();

    try {
        // Format: yyyy-MM-dd-HH-mm-ss
        const now = new Date();
        const formattedDate = now.toISOString().replace(/[-T:]/g, '_').split('.')[0];

        const provider = activeUrlStore.getProvider;
        const url = activeUrlStore.activeUrl;

        const hostname = (() => {
            try {
                return new URL(url).hostname;
            } catch {
                return 'invalid-url';
            }
        })();

        const filename = `${hostname}-notifications-${formattedDate}.json`;

        const data = {
            exportedBy: auth.getUser?.username ?? 'unknown',
            timestamp: now.toISOString(),
            provider,
            site: url,
            count: notificationStore.notifications.length,
            notifications: notificationStore.notifications,
        };

        const jsonData = JSON.stringify(data, null, 2);
        const blob = new Blob([jsonData], { type: 'application/json' });
        const objectUrl = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl);

        GoogleAnalytics.exportJsonSuccessful();
    } catch (error) {
        GoogleAnalytics.exportJsonFailed();
        console.error('Notification export failed:', error);
    }
}

export default exportNotificationsToJson;
